"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnnualEarnedIncome = AnnualEarnedIncome;
exports.BirthDay = BirthDay;
exports.CashSavings = CashSavings;
exports.EstimatedMonthlyExpenses = EstimatedMonthlyExpenses;
exports.HaveEmployerPlan = HaveEmployerPlan;
exports.PlanningIndicator = PlanningIndicator;
var _react = _interopRequireDefault(require("react"));
var _DropdownForNatLangForm = require("../Wizard/DropdownForNatLangForm");
var _TextInputForNatLangForm = require("../Wizard/TextInputForNatLangForm");
var _reactBootstrap = require("react-bootstrap");
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _DisabilityWizardCalculator = require("./DisabilityWizardCalculator.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BirthDay(_ref) {
  var {
    errors,
    touched,
    birthDay,
    birthMonth,
    birthYear,
    setFieldValue,
    setFieldTouched,
    setFieldError
  } = _ref;
  // Set birthdate field based on three separate, dependent fields
  _react.default.useEffect(() => {
    var parsedDate = (0, _parse.default)("".concat(birthMonth, "-").concat(birthDay, "-").concat(birthYear), 'M-d-y', new Date());
    setFieldValue('birthdate', parsedDate);
  }, [birthDay, birthMonth, birthYear, touched.birthdate, setFieldValue]);

  // Set birthdate touched after all three fields have been touched
  _react.default.useEffect(() => {
    setFieldTouched('birthdate', touched.birthMonth && touched.birthDay && touched.birthYear);
  }, [touched.birthDay, touched.birthMonth, touched.birthYear]);

  // Override errors in order sequential order
  _react.default.useEffect(() => {
    var firstBirthdateError = [errors.birthMonth, errors.birthDay, errors.birthYear, errors.birthdate].find(val => !!val);
    setFieldError('birthdate', firstBirthdateError);
  }, [errors.birthDay, errors.birthMonth, errors.birthYear, touched.birthDay, touched.birthMonth, touched.birthYear]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    htmlFor: "di_birthMonth"
  }, "I was born on "), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "di_birthMonth",
    name: "birthMonth",
    id: "di_birthMonth",
    placeholder: "MM",
    maxLength: "2",
    value: birthMonth,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, 'monthOfBirth').handleBlur(),
    htmlSize: 3
  })), /*#__PURE__*/_react.default.createElement("span", null, " / "), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid')
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "di_birthDay",
    name: "birthDay",
    id: "di_birthDay",
    placeholder: "DD",
    maxLength: "2",
    value: birthDay,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, 'dayOfBirth').handleBlur(),
    htmlSize: 3
  })), /*#__PURE__*/_react.default.createElement("span", null, " / "), /*#__PURE__*/_react.default.createElement(_reactBootstrap.InputGroup, {
    className: "".concat(errors.birthdate && touched.birthdate && 'is-invalid', " endOfSentence")
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    type: "text",
    inputMode: "numeric",
    "aria-label": "di_birthYear",
    name: "birthYear",
    id: "di_birthYear",
    placeholder: "YYYY",
    maxLength: "4",
    value: birthYear,
    onChange: (0, _formikMiddleware.default)().digitFilterChainHandler().handleChange(),
    onBlur: (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, 'yearOfBirth').handleBlur(),
    htmlSize: 5
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FormControl.Feedback, {
    className: "custom-feedback",
    type: "invalid",
    tooltip: true
  }, errors.birthdate), "."));
}

// Dropdown inputs start here
function HaveEmployerPlan(_ref2) {
  var {
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'haveEmployerPlan';
  var preText = 'I ';
  var postText = ' disability income insurance coverage. ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _DisabilityWizardCalculator.dropdownOptions.haveEmployerArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    postText: postText,
    calcName: _DisabilityWizardCalculator.calcName
  });
}
function PlanningIndicator(_ref3) {
  var {
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'planningIndicator';
  var preText = 'I ';
  return /*#__PURE__*/_react.default.createElement(_DropdownForNatLangForm.DropdownForNatLangForm, {
    values: values,
    dropdownArray: _DisabilityWizardCalculator.dropdownOptions.planIndArray,
    fieldName: fieldName,
    preText: preText,
    setFieldValue: setFieldValue,
    calcName: _DisabilityWizardCalculator.calcName
  });
}
// Text inputs start here
function AnnualEarnedIncome(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'annualEarnedIncome';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var preText = ' I make ';
  var postText = ' a year ';
  var htmlSize = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    preText: preText,
    postText: postText,
    htmlSize: htmlSize,
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function EstimatedMonthlyExpenses(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var fieldName = 'estimatedMonthlyExpenses';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var preText = 'and my estimated monthly expenses are ';
  var postText = ' ';
  var htmlSize = '10';
  var className = 'endOfSentence';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    preText: preText,
    postText: postText,
    htmlSize: htmlSize,
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    className: className
  });
}
function CashSavings(_ref6) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'cashSavings';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  var preText = ' to use my savings of ';
  var postText = ' during my disability.';
  var htmlSize = '10';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_DisabilityWizardCalculator.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForNatLangForm.TextInputForNatLangForm, {
    preText: preText,
    postText: postText,
    htmlSize: htmlSize,
    fieldName: fieldName,
    id: _DisabilityWizardCalculator.idPrefix + fieldName,
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}